import React from 'react';
import { string } from 'prop-types';

import { SCAlertBox, Header, Text, RejectBox, TextBox } from './styles';

CategoryAlertBox.propTypes = {
  comment: string.isRequired,
};

function CategoryAlertBox({ comment }) {
  return (
    <SCAlertBox>
      <RejectBox>
        <TextBox>
          <Header>Meddelande från Bytesansökan:</Header>
          <Text>{comment}</Text>
        </TextBox>
      </RejectBox>
    </SCAlertBox>
  );
}

export default CategoryAlertBox;



// WEBPACK FOOTER //
// ./src/components/AlertBox/CategoryAlertBox.js